import { render } from "./SVGLoader.vue?vue&type=template&id=1da467c0&ts=true"
import script from "./SVGLoader.vue?vue&type=script&lang=ts"
export * from "./SVGLoader.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\xampp\\htdocs\\Peaco-v.1\\PEACO\\peacohrm-main\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__